module.exports = __webpack_public_path__ + "img/cover-papa.7261c6d8.png";